import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBookmark32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconBookmark32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m16 21.668 1.029.617L24 26.468V7a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v19.468l6.971-4.183zM16 24l6.971 4.183c1.333.8 3.029-.16 3.029-1.715V7a4 4 0 0 0-4-4H10a4 4 0 0 0-4 4v19.468c0 1.554 1.696 2.514 3.029 1.715z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBookmark32);
